import { render, staticRenderFns } from "./StoresView.vue?vue&type=template&id=2f1ef78c"
import script from "./StoresView.vue?vue&type=script&lang=js"
export * from "./StoresView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports